import { Type } from "class-transformer";
import { observable } from "mobx";
import type TransferType from "./transferType";
import UnpairedPaymentStatus from "./unpairedPaymentStatus";
import RecipientBankAccount from "./recipientBankAccount";
import SenderBankAccount from "./refund/senderBankAccount";

export default class UnpairedPayment {
  id: string;
  variableSymbol: string;
  specificSymbol: string;
  constantSymbol: string;
  messageForRecipient: string;
  paidAmount: number;
  @Type(() => Date)
  postingDate: Date;
  @observable status: UnpairedPaymentStatus;
  externalBankTransactionId: string;
  bankTransactionId: string;
  @Type(() => RecipientBankAccount)
  recipientBankAccount: RecipientBankAccount;
  paymentType: TransferType;
  senderName: string;
  senderAddress?: string;
  @Type(() => SenderBankAccount)
  senderBankAccount: SenderBankAccount;
  isPairable: boolean;
  isRefundable: boolean;

  // Virtual FE attribute - is set when payment is just paired but still present at unpaired payment list
  @observable isPaired = false;
}
